import script from "./SearchInputWithResultSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInputWithResultSelection.vue?vue&type=script&setup=true&lang=ts"

import "./SearchInputWithResultSelection.vue?vue&type=style&index=0&id=13fce4dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fce4dd"]])

export default __exports__